import { Property } from "../RadObject";
import { IListOfExpression, ListOfExpression, ListOfExpressionPropertyValues } from "./ListOfExpression";
import { NAMESPACE } from "./_Namespace";

export type AndExpressionPropertyValues =
    ListOfExpressionPropertyValues
    & {
    };

export type AndExpressionProperties = {
    [name in keyof AndExpressionPropertyValues]: Property<AndExpressionPropertyValues[name]>
};

export interface IAndExpression extends IListOfExpression, AndExpressionProperties
{
}

export class AndExpression extends ListOfExpression<AndExpressionPropertyValues> implements IAndExpression
{
    public static override classNamespace = NAMESPACE + "AndExpression";
    public static override className = "AndExpression";
}
